export default __webpack_public_path__ + "static/media/screen_facebook_3_2.3d4067b1.png";